export default "__VITE_ASSET__BE5SBuQa__"